import React, { useEffect, useState, useContext } from "react";
import SectionCard from "../components/SectionCard";
import ConfirmDialog from "../components/ConfirmDialog";
import { Truck } from "lucide-react";
import { toast } from "react-toastify";
import { GlobalContext } from "../../../../Context/GlobalContext";

import useOrderSettings from "../../../Services/OrderServices/OrderSettingsServices/useOrderSettings";

export default function ServicesSection({ userID }) {
  const {getOrderTypeOptions, updateOrderTypeOptions}=useOrderSettings();

  const { api } = useContext(GlobalContext);
  const [services, setServices] = useState([]);
  const [confirm, setConfirm] = useState({ open:false, onConfirm:null, title:"", message:"" });

  const ask = (title, message, cb) => setConfirm({ open:true, title, message, onConfirm:() => { setConfirm({ open:false }); cb(); }});
  const cancel = () => setConfirm({ open:false, onConfirm:null, title:"", message:"" });

 const load = async () => {
  if (!userID) return;

  try {
    const result =
      await getOrderTypeOptions(userID);

    if (result.success) {
      setServices(result.data);
    } else {
      setServices([]);
      // optional:
      // toast.error(result.message);
    }
  } catch {
    setServices([]);
  }
};


const toggle = (orderType, status) => {
  ask(
    `Toggle ${orderType.replaceAll("_", " ")}?`,
    "Proceed to update the service.",
    async () => {
      try {
        const result =
          await updateOrderTypeOptions({
            userid: userID,
            orderType,
            status: status === "Y" ? "N" : "Y",
          });

        if (result.success) {
          toast.success(result.message);
          load();
        } else {
          toast.error(result.message);
        }
      } catch {
        toast.error("Failed");
      }
    }
  );
};

  useEffect(() => { load(); }, [userID]); // eslint-disable-line

  return (
    <>
      <SectionCard icon={Truck} title="Activate / Deactivate Services">
        <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
          {(services || []).map((s) => (
            <div key={s.id} className="flex items-center justify-between rounded-xl border border-gray-100 bg-white px-4 py-3 shadow-sm">
              <div className="text-sm font-medium capitalize text-gray-900">{s.orderType.replaceAll("_", " ")}</div>
              <button
                onClick={() => toggle(s.orderType, s.status)}
                className={
                  "rounded-lg px-3 py-1.5 text-sm font-semibold " +
                  (s.status === "Y"
                    ? "bg-rose-600 text-white hover:bg-rose-700"
                    : "bg-emerald-600 text-white hover:bg-emerald-700")
                }
              >
                {s.status === "Y" ? "Deactivate" : "Activate"}
              </button>
            </div>
          ))}
        </div>
      </SectionCard>
      <ConfirmDialog {...confirm} onCancel={cancel} />
    </>
  );
}
